import { FormattedMessage } from 'react-intl';

import { createColumnDefinitionBuilder } from 'ui-components/components/react-table-wrapper/create-column-definition-builder';

import { NameCell } from './name-cell';
import { tableMessages } from '../../messages';

export const createNameColumnDefinition = createColumnDefinitionBuilder({
  accessor: 'name',
  Header: <FormattedMessage {...tableMessages.headers.name} />,
  Cell: NameCell,
  width: 3,
  minWidth: 200,
});
